import { FC, useState } from 'react';
import styles from '../FieldWorkoutBuilderModal.module.scss';

interface Data {
  name: string;
  description: string;
  sport: string;
  tags: string[];
}

interface Props {
  data: Data;
  onChange: (d: Partial<Data>) => void;
}

const SPORT_OPTIONS = [
  { value: '', label: '— Nessuno —' },
  { value: 'soccer', label: 'Calcio' },
  { value: 'rugby-union', label: 'Rugby' },
  { value: 'basket', label: 'Basket' },
  { value: 'volley-ball', label: 'Pallavolo' },
  { value: 'athletics', label: 'Atletica' },
];

const MetadataStep: FC<Props> = ({ data, onChange }) => {
  const [tagInput, setTagInput] = useState('');

  const addTag = (raw: string) => {
    const t = raw.trim().replace(/,$/, '');
    if (t && !data.tags.includes(t)) {
      onChange({ tags: [...data.tags, t] });
    }
    setTagInput('');
  };

  return (
    <div className={styles.section}>
      <div className={styles.fieldsGrid}>
        <div className={styles.fieldGroup} style={{ gridColumn: '1 / -1' }}>
          <label className={styles.label}>Nome *</label>
          <input
            className={styles.input}
            placeholder="Es. Allenamento tattico settimana 12"
            value={data.name}
            onChange={(e) => onChange({ name: e.target.value })}
          />
        </div>

        <div className={styles.fieldGroup} style={{ gridColumn: '1 / -1' }}>
          <label className={styles.label}>Descrizione</label>
          <textarea
            className={styles.textarea}
            placeholder="Obiettivi, focus tecnico-tattico, note generali..."
            value={data.description}
            onChange={(e) => onChange({ description: e.target.value })}
            rows={3}
          />
        </div>

        <div className={styles.fieldGroup}>
          <label className={styles.label}>Sport</label>
          <select
            className={styles.select}
            value={data.sport}
            onChange={(e) => onChange({ sport: e.target.value })}
          >
            {SPORT_OPTIONS.map((s) => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.fieldGroup} style={{ gridColumn: 'span 2' }}>
          <label className={styles.label}>Tag</label>
          <div className={styles.tagsContainer}>
            {data.tags.map((t, i) => (
              <span key={i} className={styles.tagChip}>
                {t}
                <button
                  type="button"
                  className={styles.tagChipRemove}
                  onClick={() => onChange({ tags: data.tags.filter((_, idx) => idx !== i) })}
                >
                  ×
                </button>
              </span>
            ))}
            <input
              className={styles.tagInput}
              placeholder={data.tags.length === 0 ? 'Aggiungi tag...' : ''}
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={(e) => {
                if ((e.key === 'Enter' || e.key === ',') && tagInput.trim()) {
                  e.preventDefault();
                  addTag(tagInput);
                }
                if (e.key === 'Backspace' && !tagInput && data.tags.length > 0) {
                  onChange({ tags: data.tags.slice(0, -1) });
                }
              }}
              onBlur={() => {
                if (tagInput.trim()) addTag(tagInput);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetadataStep;
